export default __webpack_public_path__ + "static/media/myinfo_5.ea6b004d.png";